namespace GeniuzPOS.InitialData {
    export interface PsCorperateMessageForm {
        Status: Serenity.RadioButtonEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        TimeFg: Serenity.RadioButtonEditor;
        StartTime: Common.EditTimeEditor;
        EndTime: Common.EditTimeEditor;
        Topic: Serenity.StringEditor;
        Desc: Serenity.HtmlContentEditor;
        ActiveBy: Serenity.StringEditor;
        Activedate: Serenity.DateEditor;
    }

    export class PsCorperateMessageForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCorperateMessage';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCorperateMessageForm.init)  {
                PsCorperateMessageForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.DateEditor;
                var w2 = Common.EditTimeEditor;
                var w3 = s.StringEditor;
                var w4 = s.HtmlContentEditor;

                Q.initFormType(PsCorperateMessageForm, [
                    'Status', w0,
                    'StartDate', w1,
                    'EndDate', w1,
                    'TimeFg', w0,
                    'StartTime', w2,
                    'EndTime', w2,
                    'Topic', w3,
                    'Desc', w4,
                    'ActiveBy', w3,
                    'Activedate', w1
                ]);
            }
        }
    }
}
